export enum HttpRequestEnum {
    GET = "GET",
    POST = "POST"
}
